import { useContext } from 'react';
import { Grid, TextField } from '@material-ui/core';
import { qrCodeInfoContext } from '../QrCodeCheckContext';
import { FilterContainer, SearchButton } from 'components';


let Filters = () => {
    let service = useContext(qrCodeInfoContext);

    return (
        <FilterContainer onSubmit={() => service.doSearch()}>
            <Grid item xs={2}>
                <TextField
                    variant="outlined"
                    label="QrCode"
                    value={service.qrCodeSearch}
                    onChange={(e: any) => service.updateSearch(e.target.value)}
                />
            </Grid>
            <Grid item>
                <SearchButton type='submit' />
            </Grid>
        </FilterContainer>
    )
}

export default Filters;